import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'

import { Button } from '@independent-software/typeui/controls/Button'
import { Icon } from '@independent-software/typeui/controls/Icon'
import { Panel } from '@independent-software/typeui/controls/Panel'
import { Label } from '@independent-software/typeui/controls/Label'
import { List } from '@independent-software/typeui/controls/List'

interface IProps {
  className?: string;
  /** Callback called when an export option is clicked. */
  onExport: (format: string) => void;
}

const ExportBase = (props: IProps) => {
  const [open, setOpen] = React.useState(false);
  
  // Toggle panel.
  const handleClick = () => setOpen(!open);

  // Close panel.
  const handleClose = () => setOpen(false);

  // An export option was selected. Inform the parent.
  const handleExport = (format: string) => {
    setOpen(false);
    props.onExport(format);
  }

  return (
    <div className={props.className}>
      <span>
        <Button secondary size='tiny' onClick={handleClick}>
          <Label color="#000"><Icon color="#fff" name='file-download'/></Label>
          Export
        </Button>
        <Panel open={open} onClose={handleClose} width={280}>
          <List animated divided selection relaxed align="center">
            <List.Item onClick={() => handleExport('excel')}>
              <Icon size="large" name="file-excel"/>
              <List.Content>
                <List.Header>Microsoft Excel</List.Header>
                <List.Description>Export to .xlsx</List.Description>
              </List.Content>
            </List.Item>
            <List.Item onClick={() => handleExport('csv')}>
              <Icon size="large" name="file-csv"/>
              <List.Content>
                <List.Header>Comma-separated values</List.Header>
                <List.Description>Export to .csv</List.Description>
              </List.Content>
            </List.Item>
            <List.Item onClick={() => handleExport('ods')}>
              <Icon size="large" name="file-ods"/>                
              <List.Content>
                <List.Header>Open Office</List.Header>
                <List.Description>Export to .ods</List.Description>
              </List.Content>
            </List.Item>                        
          </List>
        </Panel>
      </span>
    </div>
  )
}

const Export = styled(ExportBase)`
  &>span {
    text-align: left;
  }
`

export { Export }
